import { JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

  checklist_form : FormGroup

  checklist_model = {
    displayname: '',
    name: '',
    description: '',
    body: '',
    notes: '',
    admin_notes: '',
    emp_type:'',
    type:''
  }
 sprint_model={
    checklist: '',
    enrolment: null,
    sprint_data: [
      {
        data: {}
      }
    ]
 }
  checklist_id:any
  checklist_data:any
  currentUrl:any
  emp_typeList=[];
  emp_typeId=  "6344000d91f6bc691e775faf" 
  selected_emp_type=null
  list_type =[]
  selected_type_list=null
  selected_type_name=''
  keyValues: any[] = [];
  key_Values: any[] = [];
  resultObject ={}
  row_json_data:any
  row_json_dataa =[]
  sprint_id:any;
  sprint_data_id:any
  sprint_check_id:any
  constructor(private formBuilder: FormBuilder,private apiService : ApiService,
              public toastr: ToastrService,private route:Router,
              private activerouter: ActivatedRoute,) { 
                this.currentUrl = this.activerouter.snapshot.routeConfig.path
                this.activerouter.paramMap.subscribe(params => {
                  this.checklist_id = params.get('id');
                })
              }

  ngOnInit() {

    this.checklist_form = this.formBuilder.group({
      displayname: ['', ],
      name:  ['', ],
      description:  ['', ],
      body:  ['', ],
      notes:  ['', ],
      admin_notes:  ['', ],
      sprint : ['',]
    })

    if(this.currentUrl === 'edit/:id'){
      this.getChecklistById(this.checklist_id)
    }
    this.getEmployeeType()
    this.getCheckListType()

  }
  get rf() {
    return this.checklist_form.controls;
  }
  getCheckListId(id){
      this.apiService.getSprintByChecklistId(id).subscribe((res:any)=>{
        this.sprint_id = res?.data[0]?.sprint[0]._id
        this.sprint_data_id = res?.data[0]?.sprint[0]?.sprint_data[0]._id
        let data = res?.data[0]?.sprint[0]?.sprint_data[0].data
        this.key_Values = Object.entries(data)
      })
  }
  getChecklistById(id){
    this.apiService.getChecklistById(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.checklist_data = res?.data[0]
        this.checklist_model.displayname = this.checklist_data?.displayname
        this.checklist_model.name = this.checklist_data?.name
        this.checklist_model.body = this.checklist_data?.body
        this.checklist_model.description = this.checklist_data?.description
        this.checklist_model.notes = this.checklist_data?.notes
        this.checklist_model.admin_notes = this.checklist_data?.admin_notes
        if(this.checklist_data?.emp_type){
          this.selected_emp_type = this.checklist_data?.emp_type.map(item =>item._id)
          this.checklist_model.emp_type = this.selected_emp_type
        }
        if(this.checklist_data?.type){
          this.selected_type_list = this.checklist_data?.type[0]?._id
          this.checklist_model.type = this.selected_type_list
          this.selected_type_name =this.checklist_data?.type[0]?.name
          this.sprint_check_id = this.checklist_data?.sprint[0]?.checklist
        }
        if(this.sprint_check_id){
          this.getCheckListId(this.sprint_check_id)
        }
      }
    })
  }
  getEmployeeType(){
    this.apiService.getTagByTagCatgoryId(this.emp_typeId).subscribe((res:any)=>{
      this.emp_typeList=res.data
    })
  }
  getCheckListType(){
    this.apiService.getTagByTagCatgoryId('65268dbf37d5731c9401d3fe').subscribe((res:any)=>{
      this.list_type=res.data
    })
  }
  getTypeListId(event){
    this.selected_type_list
    this.selected_type_name = event.name
  }
  getTypeId(event){
    this.selected_emp_type
  }
  submit(){
    if(this.currentUrl === 'add'){
      
      this.resultObject = {};
      this.keyValues.forEach(item => {
      if (item.key && item.value) {
        this.resultObject[item.key] = item.value;
      }
      if (item.key && (item.value === 'true' || item.value === 'false')) {
        this.resultObject[item.key] = item.value === 'true';
      }
   
    });
    this.sprint_model.sprint_data[0].data = this.resultObject
      // console.log('key & value',this.resultObject)

      let body={
        emp_type:this.selected_emp_type,
        displayname: this.checklist_form.value.displayname,
        name:  this.checklist_form.value.name,
        description:  this.checklist_form.value.description,
        body:  this.checklist_form.value.body,
        notes:  this.checklist_form.value.notes,
        admin_notes:  this.checklist_form.value.admin_notes,
        type : this.selected_type_list
      } 
     
      this.apiService.createChecklist(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          if(this.selected_type_name =='quick'){
            this.sprint_model.checklist = res?.data?._id
            this.apiService.addSprint(this.sprint_model).subscribe((res:any)=>{
              if(res?.statusCode === 200){
                this.toastr.success('checklist created successfully!')
              }
              else{
                this.toastr.error(res.error)
              }
            })
          }
          
          window.history.back()  
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl === 'edit/:id'){
      this.checklist_model.emp_type = this.selected_emp_type
      if(this.selected_type_name =='quick'){
      this.resultObject = {};
      this.key_Values.forEach(item => {
        item[1]=JSON.parse(item[1])
      });
    const geek1 = Object.fromEntries(this.key_Values as any[]);
    this.sprint_model.sprint_data[0].data = geek1
        let body ={
          data : geek1
        }
        this.apiService.updateChecklistSprint( this.sprint_id,this.sprint_data_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.apiService.updateChecklist(this.checklist_id,this.checklist_model).subscribe((res:any)=>{
              if(res.statusCode === 200){
                this.toastr.success('checklist updated successfully!')
                window.history.back()  
              }
              else{
                this.toastr.error(res.error)
              }
            })
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      else {
        this.apiService.updateChecklist(this.checklist_id,this.checklist_model).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('checklist updated successfully!')
            window.history.back()  
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
   
    }
  }
  back(){
    this.route.navigate(['/checklist/list'])
  }

convertToJson(data) {
  const obj = {};
  data.split(",").forEach((val) => {
    const [key, value] = val.split(":");
    obj[key] = value.trim().toLowerCase() === "true";
  });

  // Convert the object to a JSON string if needed
  const jsonString = JSON.stringify(obj);
  this.sprint_model.sprint_data[0].data = obj
  // console.log('==>>', jsonString); // JSON string
  // console.log('obj',obj); // Object with boolean values
}
convertToJsonn(data) {
  let d = JSON.stringify(data)
  let dataa = JSON.parse(d)
  // for (const key in dataa) {
  //   if (dataa.hasOwnProperty(key)) {
  //       dataa[key] = dataa[key] === "true";
  //   }
  // }
}
addItem() {
  this.keyValues.push({ key: '', value: '' });
}
addItemm(){
  this.key_Values.push({ key: '', value: '' });
}
convertToBoolean(value: string): boolean {
  return value.toLowerCase() === 'true';
}
removeItemm(index: number) {
  this.key_Values.splice(index, 1);
}
removeItem(index: number) {
  this.keyValues.splice(index, 1);
}
isSubmitDisabled(): boolean {
  return (
    !this.checklist_model.displayname ||
    !this.checklist_model.name ||
    !this.selected_type_list  );
}
}
